import React from "react";

/**
 * UniqueFeatures.jsx
 * Single-file component with CSS included (style tag).
 *
 * Usage:
 *  import UniqueFeatures from "./components/UniqueFeatures";
 *  <UniqueFeatures />
 */

export default function UniqueFeatures() {
  const bullets = [
    "Supersteno is based on latest NLP Technology which converts your voice into text with maximum accuracy. Supersteno can be used on your PC, Laptop or Mobile.",
    "The turbo software is enabled to convert speech into text on real time basis.",
    "Supersteno is smart enough to recognize different voices, accents and dialects — so no special voice training needed.",
    "Now no need to find out stenos and wait for them to take your dictation and type the document — with Supersteno you get documents typed conveniently from anywhere.",
    "Super accuracy of Supersteno requires minimum corrections.",
    "Add paragraphs and punctuation marks (Full stop, comma, brackets, question mark etc.) with simple voice commands.",
    "Continuous typing with no limitations of words, pages etc."
  ];

  return (
    <>
    

      <main className="uf-main container">
        <section className="uf-features">
          <h2 className="uf-title">OUR UNIQUE FEATURES:</h2>

          <div className="uf-grid">
            <div className="uf-left">
              <ul className="uf-bullets">
                {bullets.map((t, i) => (
                  <li key={i}>
                    <span className="uf-check">✓</span>
                    <p>{t}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="uf-right">
              <div className="uf-image-wrap">
                <img
                  src="	https://supersteno.com/assetsa/img/about.jpg"
                  alt="Team discussing"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

    

      {/* Component-scoped CSS */}
      <style>{`
/* ---------- variables ---------- */
:root {
  --uf-topbar-h: 42px;
  --uf-header-h: 84px;
  --uf-container-width: 1180px;
  --uf-gap: 28px;
}

/* ---------- reset for this component ---------- */
.uf-topbar, .uf-header, .uf-main, .uf-footer { box-sizing: border-box; }

/* ---------- container helper ---------- */
.container {
  width: min(var(--uf-container-width), 94%);
  margin: 0 auto;
}

/* ---------- topbar (fixed) ---------- */
.uf-topbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: var(--uf-topbar-h);
  background: #2e2e2e;
  color: #fff;
  z-index: 1200;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.uf-topbar-inner { display:flex; align-items:center; justify-content:space-between; gap:12px; padding: 6px 0; }
.uf-social span { margin-right:12px; color: #fff; opacity:0.95; }
.uf-contact span { margin-left:14px; color:#fff; }

/* ---------- header (sticky below topbar) ---------- */
.uf-header {
  position: sticky;
  top: var(--uf-topbar-h);
  background: #fff;
  z-index: 1150;
  border-bottom: 1px solid #eee;
}
.uf-header-inner {
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 18px 0;
}

/* logo */
.uf-logo img { height:56px; object-fit:contain; display:block; }

/* nav */
.uf-nav a { margin-left:22px; text-decoration:none; color:#333; font-weight:500; }
.uf-nav a:hover { color:#0077ff; }

/* ---------- main spacing so content not hidden under topbar/header ---------- */
/* padding-top = topbar + header heights */
.uf-main { padding-top: 0px;}

/* ---------- features section ---------- */
.uf-features { padding: 0 0 30px; }
.uf-title { font-size:28px; margin:8px 0 18px; font-weight:700; color:#333; }

/* two-column grid */
.uf-grid {
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: var(--uf-gap);
  align-items: start;
}

/* left list */
.uf-left { }
.uf-bullets { list-style:none; padding:0; margin:0; display:block; }
.uf-bullets li {
  display:flex;
  gap:14px;
  align-items:flex-start;
  margin-bottom:18px;
}
.uf-check { color:#e86f22; margin-top:4px; font-weight:700; }

/* text inside bullet */
.uf-bullets p { margin:0; color:#333; line-height:1.6; }

/* right image */
.uf-image-wrap {
  background:#fff;
  border-radius:6px;
  overflow:hidden;
  box-shadow: 0 8px 30px rgba(0,0,0,0.06);
}
.uf-image-wrap img { width:100%; height:100%; display:block; object-fit:cover; }

/* footer */
.uf-footer { padding:24px 0; text-align:center; background: #fafafa; color:#666; border-top: 1px solid #f0f0f0; }

/* ---------- responsive ---------- */
@media (max-width: 1100px) {
  .uf-grid { grid-template-columns: 1fr 360px; }
  .uf-image-wrap img { object-position:center; }
}
@media (max-width: 900px) {
  .uf-grid { grid-template-columns: 1fr; }
  .uf-image-wrap { order: 2; margin-top:16px; }
  .uf-main { padding-top: 0px; }
  .uf-title { font-size:22px; }
}
@media (max-width: 520px) {
  .uf-topbar-inner { flex-direction:row; justify-content:space-between; gap:8px; padding:6px 4%; }
  .uf-contact { font-size:13px; }
  .uf-header-inner { padding:12px 0; }
  .uf-logo img { height:44px; }
  .uf-main { padding-top: 0px; }
  .uf-image-wrap { width:100%; height:auto; }
}
      `}</style>
    </>
  );
}
